import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';


import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';


import { green } from '@mui/material/colors';

const styles = theme => ({

    info: {
        fontStyle: 'italic'
    },
    infoWarning: {
        color: theme.palette.secondary.main,
        fontWeight: 'bold'
    },
    link: theme.style.link,

    cardActions: {
        justifyContent: 'right'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }    
});

class TransporteurLinks extends React.Component {

    render() {
        const { classes, urlSuiviColis, login, pwd, transporteurNom, isAdding, onClickDone, fallbackMode, fallbackComponent, onClickFallback } = this.props;        

        return (
            <div>
                
                <Card>

                    <CardContent>


                        <p>Veuillez vous rendre sur le site du transporteur <span className={classes.info}>{transporteurNom}</span> en cliquant sur le numéro de BT suivant:</p>

                        {urlSuiviColis.map((url, index) => (
                            <p key= { index } >
                                <a target="_blank" href={url.adresse} rel="noopener noreferrer" className={classes.link}>
                                <Typography variant="button">
                                    {url.recepisse}
                                </Typography>
                                </a>
                            </p>
                        ))}

                        <p>Identifiant : <span className={classes.info}>{login}</span></p>
                        <p>Mot de passe  : <span className={classes.info}>{pwd}</span></p>


                        <p>
                            En cas d'impossibilité d'accèder au site du transporteur, veuillez cliquer sur "envoyer l'info au service transport"
                        </p>

                    </CardContent>

                    <CardActions classes={{ root: classes.cardActions }}>

                        <Button
                            onClick={onClickFallback}
                            variant="contained" 
                            color="correct"
                            disabled={fallbackMode}
                        >
                            Envoyer l'info au service transport
                        </Button>

                        <Button
                            onClick={onClickDone}
                            variant="contained"
                            color="secondary"
                            disabled={isAdding || fallbackMode}
                        >
                            {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                            C'est fait !
                        </Button>

                    </CardActions>


                </Card>



                {fallbackMode && fallbackComponent}


            </div>
        );
    }
}
TransporteurLinks.propTypes = {
    urlSuiviColis: PropTypes.array.isRequired
};

export default withStyles(styles)(TransporteurLinks);